import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import TitulosSelecionados from '../CTitulosSelecionados';
import moment from 'moment';

export default function Step02() {

  const { control, getValues, watch, setValue } = useFormContext();
  const formRecb = watch('dados_recebimento.forma_recebimento')
  const isPix = formRecb === 'emitir pix'
  const proibirRetroagir = getValues('funcoesAux.proibidoSelectTitulos')
  const funcaoTroca = watch('funcaoTroca')

  //valores importantes
  const opcoesRadio: IOpcoesRadio[] = useMemo(() => [
    {
      value: "registrar recebimento",
      label: "Registrar recebimento",
      sublabel: '(Você informa manualmente o valor e a forma de recebimento)',
      disabled: Boolean(funcaoTroca)
    },
    {
      value: "emitir boleto bancario",
      label: "Emitir boleto bancário",
      sublabel: '(O recebimento só será registrado após a compensação bancária)',
      disabled: Boolean(funcaoTroca)
    },
    {
      value: "emitir pix",
      label: "PIX instantâneo",
      sublabel: '(Um QRCode é gerado para pagamento em até 5 minutos)',
      disabled: Boolean(funcaoTroca)
    },
    {
      value: "compensacao",
      label: "Compensação",
      sublabel: '(Registra recebimento através de compensação de títulos a pagar)'
    },
  ], [funcaoTroca])
  //

  //funcoes manipuladoras
  const handleNext = getValues('funcoesAux.onNext')
  const handleBack = getValues('funcoesAux.onBack')

  const handleAvancar = () => {
    if (isPix) {
      setValue('finalizacao.data_recebimento', moment())
    }
    handleNext()
  }
  //

  return (
    <>
      <Grid container justifyContent='space-between' paddingTop={3}>
        <Grid size={{xs: 12, md: 6}}>
          <Box>
            <Typography variant='h6'>Escolha uma opção</Typography>

            <Controller
              control={control}
              rules={{ required: "Campo obrigatório" }}
              name='dados_recebimento.forma_recebimento'
              render={({ field }) => {
                return (
                  <FormControl {...field} style={{}}>
                    <FormLabel id="dadosRecebimento">
                      <Typography variant='body1'>Como você deseja baixar os títulos selecionados?</Typography>
                    </FormLabel>

                    <RadioGroup
                      value={field.value}
                      defaultValue={getValues("dados_recebimento.forma_recebimento")}
                      style={{ gap: "16px", marginTop: "24px" }}
                    >
                      {
                        opcoesRadio.map((opcao, index) => (
                          <FormControlLabel
                            key={index}
                            value={opcao.value}
                            control={<Radio />}
                            disabled={opcao.disabled}
                            label={
                              <Box>
                                <Typography variant='body1' fontWeight={'bold'}>{opcao.label}</Typography>
                                {
                                  opcao.sublabel &&
                                  <Typography variant='caption'>{opcao.sublabel}</Typography>
                                }
                              </Box>
                            }
                          />
                        ))
                      }
                    </RadioGroup>
                  </FormControl>
                )
              }}
            />
          </Box> 
        </Grid>

        <Grid size={{xs: 12, md: 6}}>
          <Box display="flex" justifyContent="flex-end">
            <TitulosSelecionados />
          </Box>
        </Grid>
      </Grid>

      <Box width={'100%'} display={'flex'} justifyContent={'flex-end'} gap={2} mt={2}>
        {
          !proibirRetroagir &&
          <Button
            onClick={handleBack}
          >
            Voltar
          </Button>
        }
        <Button
          variant="contained"
          onClick={handleAvancar}
        >
          Avançar
        </Button>
      </Box>
    </>
  )
}


interface IOpcoesRadio {
  value: string;
  label: string;
  sublabel?: string;
  disabled?: boolean;
}